import { DEFAULT_CENSOR_MASK } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { mutateObject } from 'cpool-utils';
import { z } from 'zod';

import type { EventSchema } from '../../../utils/EventSchema';
import { _Event } from '../../_Event';

export class LoanRequest_NoteAdded extends _Event {
    constructor(payload: EventSchema<LoanRequest_NoteAdded>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            author: z.object({
                firstName: z.string(),
                id: schemaId,
                lastName: z.string(),
            }),
            content: z.string().min(1),
            favored: z.boolean().default(false),
            id: schemaId,
        });
    }

    static example(): EventSchema<LoanRequest_NoteAdded> {
        return {
            author: {
                firstName: 'Max',
                id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
                lastName: 'Mustermann',
            },
            content: 'This is a valid note content.',
            favored: false,
            id: '7f2def23-f1ad-4c6b-9c84-1218e0c794e7',
        };
    }

    static exampleCensored(): EventSchema<LoanRequest_NoteAdded> {
        return {
            ...LoanRequest_NoteAdded.example(),
            content: DEFAULT_CENSOR_MASK,
        };
    }

    getCensoredSchema() {
        return this.getSchema().transform((data) => mutateObject(data, { content: DEFAULT_CENSOR_MASK }));
    }
}
